import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=9842f9ae&scoped=true"
import script from "./OrderData.vue?vue&type=script&lang=js"
export * from "./OrderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9842f9ae",
  null
  
)

export default component.exports